// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/model_card_component.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ModelCardComponent
 */
export interface ModelCardComponent {
    /**
     * Data regarding the model card
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.ModelCardComponent.ModelCardAttributes model_card_attributes = 3;
     */
    modelCardAttributes?: ModelCardComponent_ModelCardAttributes;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ModelCardComponent.ModelCardAttributes
 */
export interface ModelCardComponent_ModelCardAttributes {
    /**
     * Added price field
     *
     * @generated from protobuf field: double price = 1;
     */
    price: number;
    /**
     * The name of the model
     *
     * @generated from protobuf field: string model_name = 2;
     */
    modelName: string;
    /**
     * The cluster of the model
     *
     * @generated from protobuf field: string cluster = 3;
     */
    cluster: string;
    /**
     * The id of the model
     *
     * @generated from protobuf field: string id = 4;
     */
    id: string;
    /**
     * The id of the impression
     *
     * @generated from protobuf field: string imp = 5;
     */
    imp: string;
    /**
     * List of categories
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ModelCardComponent.Category categories = 6;
     */
    categories: ModelCardComponent_Category[];
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ModelCardComponent.Category
 */
export interface ModelCardComponent_Category {
    /**
     * The category ID
     *
     * @generated from protobuf field: string category_id = 1;
     */
    categoryId: string;
    /**
     * The category name
     *
     * @generated from protobuf field: string category_name = 2;
     */
    categoryName: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ModelCardComponent$Type extends MessageType<ModelCardComponent> {
    constructor() {
        super("bianka.event.activity.v2.extension.ModelCardComponent", [
            { no: 3, name: "model_card_attributes", kind: "message", T: () => ModelCardComponent_ModelCardAttributes }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ModelCardComponent
 */
export const ModelCardComponent = new ModelCardComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelCardComponent_ModelCardAttributes$Type extends MessageType<ModelCardComponent_ModelCardAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.ModelCardComponent.ModelCardAttributes", [
            { no: 1, name: "price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cluster", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "imp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "categories", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ModelCardComponent_Category }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ModelCardComponent.ModelCardAttributes
 */
export const ModelCardComponent_ModelCardAttributes = new ModelCardComponent_ModelCardAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelCardComponent_Category$Type extends MessageType<ModelCardComponent_Category> {
    constructor() {
        super("bianka.event.activity.v2.extension.ModelCardComponent.Category", [
            { no: 1, name: "category_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "category_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ModelCardComponent.Category
 */
export const ModelCardComponent_Category = new ModelCardComponent_Category$Type();
